// @flow
import styled, { css } from 'styled-components';
import { media } from '~/core/utils/style';

export const DiscoveryActions = styled.div`
    display: flex;
    flex-direction: column;
    margin-top: 1em;

    ${media.desktop`
		flex-direction: row;
	`};
`;

export const FirstColumn = styled.div`
    border-bottom: solid 1px ${p => p.theme.secondaryMedium};
    display: flex;
    flex: 0 0 35%;
    justify-content: center;
    margin-bottom: 1em;
    padding-bottom: 1em;

    ${media.desktop`border-bottom: none`};
`;
export const SecondColumn = styled.div`
    flex: 1 0 65%;
    margin-left: 0;

    ${media.desktop`
        ${p =>
            p.showFilter &&
            css`
                border-left: solid 1px ${p => p.theme.secondaryMedium};
                margin-left: 1em;
                padding-left: 1em;
            `}
	`};
`;

export const FilterStatus = styled.div`
    align-items: flex-start;
    display: flex;
    height: 2em;
    justify-content: center;
`;



// WEBPACK FOOTER //
// ./src/components/widgets/actions/entry/discover-actions/styles.js